import React from 'react';
import FemboyList from './components/FemboyList';

const App: React.FC = () => {
  return (
    <div className="App">
      <FemboyList />
    </div>
  );
};

export default App;
